import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-377e6174"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "places-page" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "legend" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, " Ancestor birth countries ", -1))
const _hoisted_6 = { class: "list-unstyled" }
const _hoisted_7 = { class: "count" }
const _hoisted_8 = { class: "earth-area" }

import { computed, onMounted, ref, watch } from 'vue'
import { useExploreStore } from '../ExploreStore'
import { useViewScopeStore } from '../ViewScopeStore'
import { usePlaceAnalysis } from './PlaceAnalysis'
import { getSortedValueCounts } from '@/util/AnalysisUtil'
import { CountryCodes } from '@/util/GeoUtil'
import { MapPinIcon } from '@zhuowenli/vue-feather-icons'
import { LoadMode } from '@/util/AsyncData'
import Earth from '@/explore/Earth.vue'

interface CountryCount {
  code: string
  text: string
  count: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlacesPage',
  setup(__props) {

const sortedCountryCountsRef = ref<CountryCount[]>([])
const earthRef = ref<InstanceType<typeof Earth>>()

const exploreStore = useExploreStore()
const viewScopeStore = useViewScopeStore()
const placeAnalysis = usePlaceAnalysis()

const scopeInfoRef = computed(() => viewScopeStore.getAsyncScopeInfo(exploreStore.startPersonId, LoadMode.EnsureLoaded)?.data)

watch(scopeInfoRef, () => {
  if (scopeInfoRef.value) {
    const countryCodes = [...placeAnalysis.getScopeCountryCodes(scopeInfoRef.value)]
    sortedCountryCountsRef.value = getSortedValueCounts(countryCodes)
      .map(vc => ({ code: vc.value, text: CountryCodes.toName(vc.value)!, count: vc.count }))
      .sort((a, b) => b.count - a.count || a.text.localeCompare(b.text))
  }
}, { immediate: true })

watch(sortedCountryCountsRef, refreshMarkers)

onMounted(() => {
  // only move to client location if available on page load
  const clientLocation = exploreStore.asyncClientLocation.data
  if (clientLocation) {
    earthRef.value?.addMarker("client", clientLocation)
    earthRef.value?.moveToMarker("client")
  }

  refreshMarkers()
})

function refreshMarkers() {
  earthRef.value?.clearCountryFlags()

  for (const cc of sortedCountryCountsRef.value) {
    earthRef.value?.addCountryFlag(cc.code)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, [
        _createVNode(_unref(MapPinIcon), { size: "0.9x" }),
        _createTextVNode(" Places ")
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedCountryCountsRef.value, (cc) => {
            return (_openBlock(), _createElementBlock("li", {
              key: cc.code
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["flag fi", 'fi-' + cc.code.toLowerCase()])
              }, null, 2),
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(cc.text) + " ", 1),
                _createElementVNode("span", _hoisted_7, "(" + _toDisplayString(cc.count) + ")", 1)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(Earth, {
          ref_key: "earthRef",
          ref: earthRef,
          mode: "globe"
        }, null, 512)
      ])
    ])
  ]))
}
}

})